export class Dialog {
  constructor() {
    this.visible = false;
    this.edit = false;
    this.content = {};
  }
  open(content, edit) {
    this.visible = true;
    this.edit = edit;
    this.content = content;
  }
  close() {
    this.visible = false;
  }
  static Build() {
    return new Dialog({ visible: false, edit: false, content: {} });
  }
}
